<template>
	<div class="main-header align-c minwidth">
		<div class="mx1360 align-c between">
			<div @click="goPage('/index')" class="logo align-c">
				<img src="@/static/new/logo-white.jpg" class="p" />
			</div>
			<div class="rightbox align-c">
				<ul class="menu align-c" v-if="ismenu">
					<li @click="goPage('/coreBusiness')" class="cur curadm" :class="name=='核心业务'?'on':''">核心业务</li>
					<li @click="goPage('/assetDatabase')" class="cur curadm" :class="name=='资产数据库'?'on':''">资产数据库</li>
					<li @click="goPage('/solution')" class="cur curadm" :class="name=='解决方案'?'on':''">解决方案</li>
					<li @click="goPage('/about')" class="cur curadm" :class="name=='关于我们'?'on':''">关于我们</li>
				</ul>
				<i class="el-icon-menu btn-menu cur curadm"></i>
				<!-- <div class="user align-c" v-if="!islogin">
					<div class="login-btn cur curadm" @click="tologin()">登录</div>
					<div class="register-btn vcenter cur curadm" @click="toregister()">免费注册</div>
				</div>
				<div class="user align-c" v-if="islogin">
					欢迎，<div class="username cur curadm hideLine1" @click="toUserCenter">{{$store.state.userInfo.username}}</div> <div class="header-loginout vcenter cur curadm" @click="loginout()">退出</div>
				</div> -->
			</div>
		</div>
		<login ref="login" @loginok="loginok" @regok="regok"></login>
		<tooltips ref="tooltips" @topersonal="topersonal"></tooltips>
		<personal ref="personal"></personal>
	</div>
</template>

<script>
import util from "@/common/util.js";
import login from "@/components/login/login"
import tooltips from "@/components/tooltips/tooltips"
import personal from "@/components/personal/personal"
export default {
	name: 'myheader',
	components:{
		login,
		tooltips,
		personal
	},
	props: {
		//外部参数示例
		name: {
		    type: String,
		    default: ""
		},
		ismenu:{
			type: Boolean,
			default: true
		}
	},
	data() {
		return {
			// 内部参数
			islogin:false,
			username:"",
		}
	},
	methods: {
		goPage(path) {
			util.tourl(path)
		},
		toUserCenter(){
			util.tourl("/userCenter/index")
		},
		tologin(){
			this.$refs.login.type=1
			this.$store.commit("openlogin")
		},
		toregister(){
			this.$refs.login.type=2
			this.$store.commit("openlogin")
		},
		loginok(e){
			this.islogin = true
		},
		regok(e){
			this.islogin = true
			var userinfo = e
			this.username = userinfo.mobile
			this.$refs.tooltips.dialogVisible = true
		},
		topersonal(){
			this.$refs.personal.dialogVisible = true
		},
		loginout(){
			this.$store.commit("logout")
			this.islogin = false
		},
	},
	mounted() {
		//this.$refs.personal.dialogVisible = true
		var token = this.$store.state.token
		if (token){
			this.islogin = true
		}
	}

}
</script>

<style lang="scss" scoped>
@import "./header.scss";
</style>